export default "__VITE_ASSET__DTe7z1l4__"